import { render, staticRenderFns } from "./AddSitucontratoPage.vue?vue&type=template&id=777b842a&"
import script from "./AddSitucontratoPage.vue?vue&type=script&lang=js&"
export * from "./AddSitucontratoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports